import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlanCard } from '../../components/subscription/PlanCard';
import { useSubscriptionStore } from '../../store/subscriptionStore';
import { Spinner } from '../../components/ui/Spinner';
import { PLANS_SUBTITLE, cdnPackagesLine } from '../../texts/cdn';
import styles from './PlansPage.module.css';

export function PlansPage() {
  const navigate = useNavigate();
  const { plans, cdnPackages, loading, fetchPlans, fetchCdnPackages } = useSubscriptionStore();

  useEffect(() => {
    fetchPlans();
    fetchCdnPackages();
  }, [fetchPlans, fetchCdnPackages]);

  if (loading && plans.length === 0) {
    return (
      <div className={styles.page} style={{ textAlign: 'center', paddingTop: '4rem' }}>
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Выберите тариф</h1>
      <p className={styles.subtitle}>{PLANS_SUBTITLE}</p>
      <div className={styles.grid}>
        {plans.map((plan) => (
          <PlanCard
            key={plan.id}
            name={plan.name}
            priceKopecks={plan.priceKopecks}
            durationDays={plan.durationDays}
            maxDevices={plan.maxDevices}
            cdnTrafficBytesPerMonth={plan.cdnTrafficBytesPerMonth}
            extraKeyPriceKopecks={plan.extraKeyPriceKopecks}
            popular={plan.durationDays === 90}
            onSelect={() => navigate(`/dashboard/payment/${plan.id}`)}
          />
        ))}
      </div>
      {cdnPackages && cdnPackages.packages.length > 0 && (
        <p className={styles.topupNote}>{cdnPackagesLine(cdnPackages)}</p>
      )}
    </div>
  );
}
